/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { getUrlSync } from '@msdyn365-commerce/core';
import { IB2bRequestsStatusViewProps } from '@msdyn365-commerce-modules/account-management';
import { Button, Module, Node } from '@msdyn365-commerce-modules/utilities';
import React from 'react';

import { IB2bRequestsStatusProps, IB2bRequestsStatusResources } from '../definition-extensions/b2b-requests-status.ext.props.autogenerated';

/**
 * B2b Request status View.
 * @param props - The view props.
 * @returns The JSX Element.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention -- Dependency from module file.
const B2bRequestsStatusView: React.FC<IB2bRequestsStatusViewProps & IB2bRequestsStatusProps<IB2bRequestsStatusResources>> = props => {
    const { b2bRequestsStatus, heading, table } = props;
    const { continueShoppingButtonTitle } = props.resources;
    const initialCount = 0;

    if (props.data.operationRequests.result?.length === initialCount) {
        return (
            <Module {...b2bRequestsStatus}>
                {heading}
                <Node className=''>
                    <div className='ms-account-b2b-requests__empty-list'>
                        <h2 className='ms-account-b2b-requests__empty-list-heading'>{props.resources.headingForEmptyRequestStatus}</h2>
                        <p className='ms-account-b2b-requests__empty-list-text'>{props.resources.textForEmptyRequestStatus}</p>
                        <Node className='ms-account-b2b-requests__empty-list__btn-section'>
                            <Button
                                role='button'
                                title={continueShoppingButtonTitle}
                                aria-label={continueShoppingButtonTitle}
                                className='ms-account-b2b-requests__empty-list__btn-backtoshopping'
                                href={getUrlSync('home', props.context.actionContext)}
                            >
                                {continueShoppingButtonTitle}
                            </Button>
                        </Node>
                    </div>
                </Node>
            </Module>
        );
    }
    return (
        <Module {...b2bRequestsStatus}>
            {heading}
            {table}
        </Module>
    );
};

export default B2bRequestsStatusView;
